export default {
	our_team(state) {
		return state.our_team
	},
}
